// extracted by mini-css-extract-plugin
export default {"pageStack":"instancias_pageStack__rBO62"};